import { CopyOutlined, DeleteOutlined } from "@ant-design/icons"

export const getMenuItems = (status, styles) => {
    if (status === "published") {
        return [
            {
                key: "duplicate",
                label: "Duplicate",
                icon: <CopyOutlined style={{ color: "#4B5563" }} />,
                className: styles.menuItem
            },
            {
                key: "delete",
                label: "Delete",
                icon: <DeleteOutlined className={styles.deleteIcon} />,
                className: `${styles.deleteItem}`
            }
        ]
    }

    return [
        {
            key: "delete",
            label: "Delete",
            icon: <DeleteOutlined className={styles.deleteIcon} />,
            className: `${styles.deleteItem}`
        }
    ]
}
